<template>
  <div class="resource-view">
    <!-- <div class="resource-top">
      <div class="resource-nav">
        <small class="nav-icon">
          <i class="el-icon-back"></i>
        </small>
        <span>首页</span>
        <small class="nav-"> / </small>
        <span class="nav-link">产业资源一张图</span>
      </div>
    </div> -->
    <div class="resource-main">
      <div id="container" class="amap"></div>
      <section :class="[sectionActive ? 'section active' : 'section']">
        <small class="on-off" @click="sectionChange">
          <i
            :class="[
              sectionActive ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'
            ]"
          ></i>
        </small>
        <div class="section-control" v-show="!searchState">
          <div class="type-swith">
            <small
              :class="[swithType == 'park' ? 'active' : '']"
              @click="typeChange('park')"
            >
              产业园
            </small>
            <small
              :class="[swithType == 'building' ? 'active' : '']"
              @click="typeChange('building')"
            >
              楼宇
            </small>
            <small
              :class="[swithType == 'land' ? 'active' : '']"
              @click="typeChange('land')"
            >
              用地
            </small>
          </div>
          <p class="listTitle"></p>
          <p class="conditions_view">按条件查找</p>
          <div class="selectMain hideScrollBar">
            <el-scrollbar class="page-component__scroll" style="height: 100%">
              <div class="selectListBox" v-if="swithType === 'park'">
                <div class="select-item ">
                  <label>街道：</label>
                  <el-select
                    size="medium"
                    multiple
                    collapse-tags
                    clearable
                    v-model="parkParams.streets"
                    placeholder="请选择"
                    style="width: 249px"
                    class="custom-skin-style"
                    popper-class="custom-skin-style"
                  >
                    <el-option
                      v-for="item in streetsOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="select-item custom-skin-style">
                  <label>主导产业：</label>
                  <el-select
                    size="medium"
                    multiple
                    collapse-tags
                    clearable
                    v-model="parkParams.industry"
                    placeholder="请选择"
                    style="width: 249px"
                    popper-class="custom-skin-style"
                  >
                    <el-option
                      v-for="item in industryOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="select-item">
                  <label>建筑面积（m²）：</label>
                  <el-input
                    style="width: 80px; "
                    maxlength="12"
                    v-model="parkParams.areaTotalFrom"
                    placeholder="起始值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                  <span style="padding: 0 6px"> - </span>
                  <el-input
                    style="width: 80px"
                    maxlength="12"
                    v-model="parkParams.areaTotalTo"
                    placeholder="结束值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                </div>
                <div class="select-item">
                  <label>可出租面积（m²）：</label>
                  <el-input
                    style="width: 80px; "
                    maxlength="12"
                    v-model="parkParams.freeAreaFrom"
                    placeholder="起始值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                  <span style="padding: 0 6px"> - </span>
                  <el-input
                    style="width: 80px"
                    maxlength="12"
                    v-model="parkParams.freeAreaTo"
                    placeholder="结束值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                </div>
              </div>
              <div class="selectListBox" v-if="swithType === 'building'">
                <div class="select-item">
                  <label>街道：</label>
                  <el-select
                    size="medium"
                    multiple
                    collapse-tags
                    clearable
                    v-model="buildingParams.streets"
                    placeholder="请选择"
                    style="width: 249px"
                    popper-class="custom-skin-style"
                    class="custom-skin-style"
                  >
                    <el-option
                      v-for="item in streetsOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="select-item">
                  <label>主导产业：</label>
                  <el-select
                    size="medium"
                    multiple
                    collapse-tags
                    clearable
                    v-model="buildingParams.industry"
                    placeholder="请选择"
                    style="width: 249px"
                    class="custom-skin-style"
                    popper-class="custom-skin-style"
                  >
                    <el-option
                      v-for="item in industryOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="select-item">
                  <label>建筑面积（m²）：</label>
                  <el-input
                    style="width: 80px; "
                    maxlength="12"
                    v-model="buildingParams.areaTotalFrom"
                    placeholder="起始值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                  <span style="padding: 0 6px"> - </span>
                  <el-input
                    style="width: 80px"
                    maxlength="12"
                    v-model="buildingParams.areaTotalTo"
                    placeholder="结束值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                </div>
                <div class="select-item">
                  <label>可出租面积（m²）：</label>
                  <el-input
                    style="width: 80px; "
                    maxlength="12"
                    v-model="buildingParams.freeAreaFrom"
                    placeholder="起始值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                  <span style="padding: 0 6px"> - </span>
                  <el-input
                    style="width: 80px"
                    maxlength="12"
                    v-model="buildingParams.freeAreaTo"
                    placeholder="结束值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                </div>
                <div class="select-item">
                  <label>层高：</label>
                  <el-input
                    style="width: 80px; "
                    maxlength="12"
                    v-model="buildingParams.layerFrom"
                    placeholder="起始值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                  <span style="padding: 0 6px"> - </span>
                  <el-input
                    style="width: 80px"
                    maxlength="12"
                    v-model="buildingParams.layerTo"
                    placeholder="结束值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                </div>
                <div class="select-item">
                  <label>租金：</label>
                  <el-input
                    style="width: 80px; "
                    maxlength="12"
                    v-model="buildingParams.rentFrom"
                    placeholder="起始值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                  <span style="padding: 0 6px"> - </span>
                  <el-input
                    style="width: 80px"
                    maxlength="12"
                    v-model="buildingParams.rentTo"
                    placeholder="结束值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                </div>
              </div>
              <div class="selectListBox" v-if="swithType === 'land'">
                <div class="select-item">
                  <label>街道：</label>
                  <el-select
                    size="medium"
                    multiple
                    collapse-tags
                    clearable
                    v-model="landParams.streets"
                    placeholder="请选择"
                    style="width: 249px"
                    class="custom-skin-style"
                    popper-class="custom-skin-style"
                  >
                    <el-option
                      v-for="item in streetsOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="select-item">
                  <label>主导产业：</label>
                  <el-select
                    size="medium"
                    multiple
                    collapse-tags
                    clearable
                    v-model="landParams.industry"
                    placeholder="请选择"
                    style="width: 249px"
                    class="custom-skin-style"
                    popper-class="custom-skin-style"
                  >
                    <el-option
                      v-for="item in industryOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="select-item">
                  <label>建筑面积（m²）：</label>
                  <el-input
                    style="width: 80px; "
                    maxlength="12"
                    v-model="landParams.areaTotalFrom"
                    placeholder="起始值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                  <span style="padding: 0 6px"> - </span>
                  <el-input
                    style="width: 80px"
                    maxlength="12"
                    v-model="landParams.areaTotalTo"
                    placeholder="结束值"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    class="custom-skin-style"
                  ></el-input>
                </div>
                <!-- <div class="select-item">
                  <label>土地性质：</label>
                  <el-select
                    size="medium"
                    multiple
                    collapse-tags
                    clearable
                    v-model="landParams.industry"
                    placeholder="请选择"
                    style="width: 249px"
                  >
                    <el-option
                      v-for="item in industryOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div> -->
              </div>
            </el-scrollbar>
          </div>
          <div class="searchBox">
            <button class="determine" type="primary" @click="searchChange">
              查询
            </button>
            <button class="cancel" @click="searchClean">清空</button>
          </div>
        </div>
        <div class="section-box hideScrollBar" v-show="searchState">
          <div class="had">
            <div class="left_had">
              <el-button
                type="text"
                :disabled="listLoading"
                @click="backSearch"
              >
                <i class="el-back"></i>
              </el-button>
              <div class="total-box">
                <p>
                  共检索到 <span class="nums">{{ page.total }}</span> 条数据
                </p>
              </div>
            </div>
            <div class="right_had"></div>
          </div>
          <div class="listHeader ">
            <div class="list-item">
              <span
                >{{
                  swithType == "park"
                    ? "园区"
                    : swithType == "building"
                    ? "楼宇"
                    : swithType == "land"
                    ? "用地"
                    : ""
                }}名称</span
              >
              <span>地址</span>
              <span>建筑面积(㎡)</span>
            </div>
          </div>
          <el-scrollbar
            class="page-component__scroll"
            id="listElScroll"
            v-loading="listLoading"
            ref="myScroll"
            style="height: 100%"
          >
            <div class="local-ent-content">
              <div
                class="list_one"
                v-for="(item, index) in listData"
                :key="index"
              >
                <div class="list-item">
                  <span @click="sourceInfo(item)">{{ item.name || "--" }}</span>
                  <span>{{ item.address || "--" }}</span>
                  <span v-if="swithType === 'park'">{{
                    item.areaTotal || "--"
                  }}</span>
                  <span v-if="swithType === 'building'">{{
                    item.buildingArea || "--"
                  }}</span>
                  <span v-if="swithType === 'land'">{{
                    item.landArea || "--"
                  }}</span>
                </div>
              </div>
            </div>
            <el-empty description="暂无数据" v-if="localTotalNull"></el-empty>
          </el-scrollbar>
          <div class="custom-pagination">
            <el-pagination
              size="small"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[20, 50, 100]"
              :page-size="page.pageSize"
              layout=" prev, pager, next, jumper"
              :total="page.total"
            >
            </el-pagination>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
// import AMapLoader from "@amap/amap-jsapi-loader";
// eslint-disable-next-line no-unused-vars
import {
  buildingList,
  parkList,
  landList,
  parkListNoPage,
  buildingListNoPage,
  landListNoPage,
  // eslint-disable-next-line no-unused-vars
  getBuildingDetailById,
  // eslint-disable-next-line no-unused-vars
  getLandDetailById,
  // eslint-disable-next-line no-unused-vars
  getParkDetailById
} from "@/api/resource";
export default {
  data() {
    return {
      AMap: null,
      swithType: "park",
      localTotalNull: false,
      listLoading: false,
      sectionActive: false,
      searchState: false,
      listData: [],
      page: {
        total: 0,
        pageSize: 20,
        pageNo: 1,
        guangxi: 0
      },
      parkParams: {
        streets: [],
        industry: [],
        areaTotalFrom: "",
        areaTotalTo: "",
        freeAreaFrom: "",
        freeAreaTo: ""
      },
      buildingParams: {
        streets: [],
        industry: [],
        areaTotalFrom: "",
        areaTotalTo: "",
        freeAreaFrom: "",
        freeAreaTo: "",
        rent: "",
        layerFrom: "",
        layerTo: "",
        rentFrom: "",
        rentTo: ""
      },
      landParams: {
        streets: [],
        industry: [],
        areaTotalFrom: "",
        areaTotalTo: ""
      },
      streetsOptions: [
        "汪家街道",
        "深井子街道",
        "李石街道",
        "高湾经济区",
        "拉古街道"
      ], //街道集合
      industryOptions: [
        "物联网",
        "大数据",
        "工业互联网",
        "云计算",
        "人工智能",
        "区块链",
        "VR/AR",
        "健康食品",
        "医药品",
        "健康用品",
        "医疗器械",
        "车联网",
        "机器人与增才设备制造",
        "重大成套设备制造",
        "智能测控设备制造",
        "其他智能设备制造",
        "新材料",
        "氢能",
        "生产性服务业",
        "生活性服务业"
      ],
      layerMap: "", //打点 数据
      labelMarker: [],
      infoWin: null,
      cluster: "", //聚集点的  对象
      pointsMap: "" //聚集点 数据
    };
  },
  mounted() {
    this.getAMapInit();
    document.addEventListener("click", this.entNameInfo);
  },
  methods: {
    entNameInfo(e) {
      if (e.target.id === "jumpM") {
        let id = e.target.dataset.name;
        console.log(id);
        this.infoWindow.close();
        if (this.swithType === "park") {
          const { href } = this.$router.resolve({
            path: "/site/park",
            query: { sid: id }
          });
          window.open(href, "_blank");
        } else if (this.swithType === "building") {
          const { href } = this.$router.resolve({
            path: "/site/building",
            query: { sid: id }
          });
          window.open(href, "_blank");
        } else if (this.swithType === "land") {
          const { href } = this.$router.resolve({
            path: "/site/land",
            query: { sid: id }
          });
          window.open(href, "_blank");
        }
      } else if (e.target.id === "wiondowClose") {
        this.infoWindow.close();
      }
    },
    getAMapInit() {
      let $this = this;
      // eslint-disable-next-line no-undef
      AMapLoader.load({
        key: "950c0df7de3613bb3d721e3bf5ab11e7", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Adaptor", "AMap.MarkerCluster"],
        Loca: {
          // 是否加载 Loca， 缺省不加载
          version: "2.0" // Loca 版本，缺省 1.3.2
        }
      })
        .then(AMap => {
          $this.AMap = new AMap.Map("container", {
            resizeEnable: true,
            keyboardEnable: false,
            zoom: 7.9,
            mapStyle: "amap://styles/9d4c949a703c9ce96127d9828f918b8f"
          });
          $this.AMap.on("complete", function() {
            $this.areaChangeState = true;
            $this.searchChange();
          });
          $this.AMap.on("click", function() {
            $this.closeInfoWin();
          });
          $this.AMap.on("zoomchange", function() {
            let zoomA = $this.AMap.getZoom();
            if (zoomA >= 9) {
              $this.cluster ? $this.cluster.setData([]) : "";
            } else {
              $this.cluster ? $this.cluster.setData($this.pointsMap) : "";
            }
          });
        })
        .catch(e => {
          console.log(e);
        });
    },
    backSearch() {
      this.searchState = false;
    },
    searchClean() {
      if (this.swithType === "park") {
        this.parkParams = {
          streets: [],
          industry: [],
          areaTotalFrom: "",
          areaTotalTo: "",
          freeAreaFrom: "",
          freeAreaTo: ""
        };
      } else if (this.swithType === "building") {
        this.buildingParams = {
          streets: [],
          industry: [],
          areaTotalFrom: "",
          areaTotalTo: "",
          freeAreaFrom: "",
          freeAreaTo: "",
          rent: "",
          layerFrom: "",
          layerTo: "",
          rentFrom: "",
          rentTo: ""
        };
      } else if (this.swithType === "land") {
        this.landParams = {
          streets: [],
          industry: [],
          areaTotalFrom: "",
          areaTotalTo: ""
        };
      }
    },
    searchChange() {
      this.searchState = true;
      if (this.infoWindow) {
        this.infoWindow.close();
      }
      this.handleCurrentChange(1);
    },
    sectionChange() {
      this.sectionActive = !this.sectionActive;
    },
    typeChange(type) {
      this.swithType = type;
    },
    paramsList() {
      let params = {
        pageNum: this.page.pageNo,
        pageSize: this.page.pageSize
      };
      if (this.swithType === "park") {
        params = Object.assign(params, this.parkParams);
        params.streets = params.streets.join(",");
        params.industry = params.industry.join(",");
      } else if (this.swithType === "building") {
        params = Object.assign(params, this.buildingParams);
        params.streets = params.streets.join(",");
        params.industry = params.industry.join(",");
      } else if (this.swithType === "land") {
        params = Object.assign(params, this.landParams);
        params.streets = params.streets.join(",");
        params.industry = params.industry.join(",");
      }
      return params;
    },
    //获取列表数据
    async getLoadData() {
      let _this = this;
      this.listLoading = true;
      let params = this.paramsList();
      let listData = [];
      if (this.swithType === "park") {
        let { data } = await parkList(params);
        listData = data;
      } else if (this.swithType === "building") {
        let { data } = await buildingList(params);
        listData = data;
      } else if (this.swithType === "land") {
        let { data } = await landList(params);
        listData = data;
      }
      if (listData && listData.records && listData.records.length > 0) {
        this.listData = listData.records;
        this.page.total = listData.total;
        this.localTotalNull = false;
        this.listLoading = false;
      } else {
        this.localTotalNull = true;
        this.listData = 0;
        this.page.total = 0;
        _this.listLoading = false;
      }
      this.$refs["myScroll"].wrap.scrollTop = 0;
      this.getMapData();
    },
    async getMapData() {
      let that = this;
      let params = this.paramsList();
      let listData = [];
      if (this.swithType === "park") {
        let { data } = await parkListNoPage(params);
        listData = data;
      } else if (this.swithType === "building") {
        let { data } = await buildingListNoPage(params);
        listData = data;
      } else if (this.swithType === "land") {
        let { data } = await landListNoPage(params);
        listData = data;
      }
      this.layerMap ? this.layerMap.clear() : ""; //先清空现有打点
      this.closeInfoWin();
      let markerList = [];

      for (var i = 0; i < listData.length; i++) {
        const element = listData[i];
        if (element?.jwd) {
          markerList.push({
            lnglat: element.jwd.split(","), //点标记位置
            name: element.name,
            id: element.id
          });
        }
      }

      // 创建样式对象
      var styleObject = {
        url: require(`../../../assets/images/icic.png`), // 图标地址
        // eslint-disable-next-line no-undef
        size: new AMap.Size(30, 44), // 图标大小
        // eslint-disable-next-line no-undef
        anchor: new AMap.Pixel(15, 44) // 图标显示位置偏移量，基准点为图标左上角
      };
      // eslint-disable-next-line no-undef
      var massMarks = new AMap.MassMarks(markerList, {
        opacity: 1,
        cursor: "pointer",
        zIndex: 111, // 海量点图层叠加的顺序
        zooms: [9, 20], // 在指定地图缩放级别范围内展示海量点图层 默认取值范围为[2, 20]
        style: styleObject // 设置样式对象
      });
      massMarks.setMap(that.AMap);
      // massMarks.setData(markerList);
      massMarks.on("click", async e => {
        // that.itemInfo(item, this.AMap);(that.AMap, e, [e.data.name]);
        console.log(e.data.id);
        let params = { id: e.data.id };
        let listData = [];
        if (this.swithType === "park") {
          let { data } = await getParkDetailById(params);
          listData = data;
        } else if (this.swithType === "building") {
          let { data } = await getBuildingDetailById(params);
          listData = data;
        } else if (this.swithType === "land") {
          let { data } = await getLandDetailById(params);
          listData = data;
        }
        this.itemInfo(listData, that.AMap);
      });
      that.AMap.setFitView("", true, [50, 50, 700, 50]);
      that.layerMap = massMarks;
      that.pointsMap = markerList;

      that.hotImg(markerList);
    },
    async sourceInfo(item) {
      if (!item.jwd) {
        this.$message.error("查无经纬度");
        return false;
      }
      let params = { id: item.id };
      let listData = [];
      if (this.swithType === "park") {
        let { data } = await getParkDetailById(params);
        listData = data;
      } else if (this.swithType === "building") {
        let { data } = await getBuildingDetailById(params);
        listData = data;
      } else if (this.swithType === "land") {
        let { data } = await getLandDetailById(params);
        listData = data;
      }
      this.itemInfo(listData, this.AMap);
    },
    /**
     * 资源详情
     */
    async itemInfo(listData) {
      // eslint-disable-next-line no-undef
      let data = listData;
      if (data.picture) {
        data.picture = JSON.parse(data.picture);
      }
      let str = `
          <div id="infoBoxG">
           <b>${data.name || "--"}</b>
           <em id="wiondowClose">×</em>
          <div class="itemLi">
            <div class="infoWindow-item">
               <span>资源简介：</span>
               <span title='${data.introduction}'>${data.introduction ||
        "--"}</span>
              </div>`;
      if (data.picture && data.picture[0].url) {
        str += ` <div class="infoWindow-img">
               <img src="${data.picture[0].url}">
              </div>`;
      }
      str += `</div>`;
      str += ` <div class="itemLi">
            <span id="jumpM" data-name='${data.id}'>查看详情</span>
          </div>`;
      // 创建 infoWindow 实例
      // eslint-disable-next-line no-undef
      var infoWindow = new AMap.InfoWindow({
        content: str,
        // eslint-disable-next-line no-undef
        offset: new AMap.Pixel(0, -60)
      });
      // 打开信息窗体
      infoWindow.open(this.AMap, data.jwd.split(","));
      this.infoWindow = infoWindow;
    },
    // 打点聚合
    hotImg(val) {
      var _this = this;
      _this.cluster ? _this.cluster.setMap(null) : "";

      let list = val || [];
      var gridSize = 60;
      // 数据中需包含经纬度信息字段 lnglat

      var count = list.length;

      // eslint-disable-next-line no-unused-vars
      var _renderClusterMarker = function(context) {
        var factor = Math.pow(context.count / count, 1 / 18);
        var div = document.createElement("div");
        var Hue = 180 - factor * 180;
        var bgColor = "hsla(" + Hue + ",100%,40%,0.7)";
        var fontColor = "hsla(" + Hue + ",100%,90%,1)";
        var borderColor = "hsla(" + Hue + ",100%,40%,1)";
        var shadowColor = "hsla(" + Hue + ",100%,90%,1)";
        div.style.backgroundColor = bgColor;
        var size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
        div.style.width = div.style.height = size + "px";
        div.style.border = "solid 1px " + borderColor;
        div.style.borderRadius = size / 2 + "px";
        div.style.boxShadow = "0 0 5px " + shadowColor;
        div.innerHTML = context.count;
        div.style.lineHeight = size + "px";
        div.style.color = fontColor;
        div.style.fontSize = "14px";
        div.style.textAlign = "center";

        // eslint-disable-next-line no-undef
        context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
        context.marker.setContent(div);
      };
      // eslint-disable-next-line no-unused-vars
      var _renderMarker = function(context) {
        var content =
          '<div style="background-color: rgba(196, 204, 0, 0.7); height: 18px; width: 18px; border: 1px solid rgb(196, 204, 0); border-radius: 12px; box-shadow:  rgb(253 255 204) 0px 0px 5px;"></div>';
        // eslint-disable-next-line no-undef
        var offset = new AMap.Pixel(-9, -9);
        context.marker.setContent(content);
        context.marker.setOffset(offset);
      };

      // eslint-disable-next-line no-undef
      var cluster = new AMap.MarkerCluster(_this.AMap, list, {
        gridSize: gridSize, // 设置网格像素大小
        renderClusterMarker: _renderClusterMarker, // 自定义聚合点样式
        renderMarker: _renderMarker, // 自定义非聚合点样式
        zooms: [2, 8]
      });
      _this.cluster = cluster;
      this.listLoading = false;
      _this.AMap.setFitView("", true, [50, 50, 700, 50]);
      if (_this.AMap.getZoom() > 8) {
        _this.cluster ? _this.cluster.setMap(null) : "";
      }
      // eslint-disable-next-line no-undef
      // var cluster = new AMap.MarkerCluster(
      //   (_this.AMap, val, { gridSize: gridSize })
      // );
      // console.log(cluster);
      // cluster.setMap(_this.AMap);
    },
    //关闭 鼠标提示
    closeInfoWin() {
      let _this = this;
      if (_this.infoWin) {
        _this.infoWin.close();
        _this.infoName = "";
      }
    },
    handleSizeChange(val) {
      this.page.pageNo = 1;
      this.page.pageSize = val;
      this.getLoadData();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getLoadData();
    }
  }
};
</script>

<style lang="less" scoped>
.resource-view {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
}
.resource-top {
  height: 40px;
  background: #fff;
  border: 1px solid #dae3fa;
}
.resource-main {
  height: 0;
  flex: 1;
  position: relative;
  & .amap {
    width: 100%;
    height: 100%;
  }
}
.resource-nav {
  font-size: 14px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  line-height: 40px;
  & .nav- {
    padding: 0 4px;
  }
  & .nav-link {
    color: rgba(79, 121, 253, 1);
  }
  & .nav-icon {
    margin-right: 10px;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    background: rgba(79, 121, 253, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    & i {
      color: #fff;
    }
  }
}
.section {
  position: absolute;
  width: 485px;
  left: 0px;
  top: 0px;
  bottom: 0px;
  background: #ffffff;
  box-shadow: 0px 1px 8px 0px rgba(142, 140, 139, 0.44);
  transition: all 0.5s ease-in-out;
}
.section .on-off {
  position: absolute;
  right: -30px;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 87px;
  line-height: 87px;
  color: #1995ff;
  cursor: pointer;
  background: url("../../../assets/images/section.png") no-repeat -4px top;
}
.section .on-off i {
  font-size: 20px;
  margin-left: -4px;
}
.section.active {
  transform: translateX(-486px);
}
.left_had {
  width: 0;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.left_had .el-back {
  display: block;
  width: 22px;
  height: 22px;
  background: url("../../../assets/images/bc.png") no-repeat center center;
  margin-right: 7px;
}
.section-control {
  height: 100%;
  box-sizing: border-box;
  padding: 18px 0;
  display: flex;
  flex-direction: column;
}
.type-swith {
  display: flex;
  padding: 0 15px;
}
.type-swith small {
  color: #434343;
  font-size: 16px;
  padding: 5px 0px;
  width: 79px;
  text-align: center;
  cursor: pointer;
  background: #f7f8fa;
  border: 1px solid #a0a0a0;
  transition: 0.3s;
  &:nth-child(1) {
    border-right: 0 none;
  }
  &:nth-child(2) {
    border-right: 0 none;
  }
}
.type-swith small.active {
  color: #4f79fd;
  border-bottom: 0 none;
  background: #fff;
}
.searchBox {
  text-align: center;
  padding-top: 20px;
  .cancel {
    border: 1px solid #a0a0a0;
    background-color: #fff;
  }
}
.searchBox > .determine {
  margin-right: 20px;
  margin-left: 0;
}
.selectMain {
  height: 0;
  flex: 1;
}
.listTitle {
  padding: 10px 0;
  margin: 0 15px;
  border-bottom: 1px solid rgba(230, 228, 228, 1);
}
.conditions_view {
  padding: 15px 15px;
  font-size: 14px;
  position: relative;
  color: rgba(54, 54, 54, 1);
  font-weight: bold;
  padding-left: 25px;
  &::before {
    content: "";
    width: 2px;
    height: 15px;
    background: rgba(105, 153, 255, 1);
    position: absolute;
    left: 15px;
    top: 15;
  }
}
.select-item {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.select-item > label {
  font-size: 14px;
  color: rgba(96, 98, 102, 1);
  width: 130px;
  text-align: right;
}
.selectListBox {
  padding: 0 15px;
}
.left_had {
  width: 0;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.left_had .el-back {
  display: block;
  width: 22px;
  height: 22px;
  background: url("../../../assets/images/bc.png") no-repeat center center;
  margin-right: 7px;
}
.had {
  height: 50px;
  display: flex;
  padding: 0 20px;
  color: #555555;
  border-bottom: 1px solid #ececec;
}
.custom-pagination {
  text-align: center;
  padding: 15px 0;
}
.section-box {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.listHeader {
  margin-top: 15px;
  padding: 0 15px;
  & > div {
    height: 36px;
    line-height: 36px;
    background: rgba(80, 122, 254, 0.1);
    display: flex;
    & > span {
      padding: 0 10px;
      width: 0;
      flex: 1;
      font-size: 16px;
      color: rgba(49, 47, 47, 1);
    }
  }
}
.local-ent-content {
  padding: 0 15px;
}
.list-item {
  display: flex;
  border-bottom: 1px solid rgba(232, 232, 232, 1);
  & > span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 10px;
    width: 0;
    flex: 1;
    font-size: 14px;
    color: rgba(86, 100, 117, 1);
    padding: 12px 10px;
    &:nth-of-type(1) {
      cursor: pointer;
      &:hover {
        color: #4f79fd;
      }
    }
  }
}
.nums {
  color: rgba(227, 59, 68, 1);
  padding: 0 5px;
}
::v-deep {
  .amap-info-content {
    padding: 0;
  }
  .amap-info-close {
    display: none;
  }
  #infoBoxG {
    position: relative;
    width: 500px;
    background: #ffffff;
    box-shadow: 0px 4px 40px 0px rgba(0, 59, 168, 0.27);
    border-radius: 6px;
    overflow: hidden;
    color: rgba(43, 43, 43, 1);
    > b {
      width: 100%;
      height: 53px;
      display: flex;
      align-items: center;
      font-size: 14px;
      padding: 0 20px;
      color: rgba(80, 122, 254, 1);
      font-size: 20px;
      font-weight: normal;
      border-bottom: 1px solid rgba(235, 235, 235, 0.54);
    }
    & > em {
      position: absolute;
      right: 20px;
      top: 0;
      font-size: 25px;
      cursor: pointer;
      z-index: 2;
      height: 53px;
      display: flex;
      align-items: center;
      color: var(--color);
      font-style: normal;
    }

    .itemLi {
      padding: 10px 20px;
      > div {
        line-height: 200%;
      }
      #jumpM {
        width: 98px;
        height: 40px;
        background: rgba(80, 122, 254, 1);
        border-radius: 4px;
        color: #fff;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  .infoWindow-img {
    & img {
      display: flex;
      max-width: 90% !important;
    }
  }
  .infoWindow-item {
    display: flex;
    font-size: 14px;
    & > span:nth-of-type(1) {
      color: rgba(43, 43, 43, 1);
    }
    & > span:nth-of-type(2) {
      width: 0;
      flex: 1;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color: rgba(43, 43, 43, 0.4);
    }
  }
}
</style>
